/**
 * tutoriaBuilder — tutores, assuntos e solicitações de tutoria.
 *
 * @since H.3 (pedagógico novo)
 */
import type { $Fetch } from 'ofetch';

import {
  HttpTutorGateway, HttpAssuntoGateway, HttpSolicitacaoGateway,
} from '@/infrastructure/http/HttpTutoriaGateways';
import {
  ListTutores, CreateTutor, UpdateTutor, ArquivarTutor,
  ListAssuntos, CreateAssunto, UpdateAssunto,
  ListSolicitacoes, AssumirSolicitacao, ListSolicitacaoMensagens,
  ResponderSolicitacao, EncerrarSolicitacao,
} from '@/application/usecase/TutoriaUseCaseImpl';

export function buildTutoriaSlice(httpClient: $Fetch) {
  const tutorGateway = new HttpTutorGateway(httpClient);
  const assuntoGateway = new HttpAssuntoGateway(httpClient);
  const solicitacaoGateway = new HttpSolicitacaoGateway(httpClient);

  const useCases = {
    listTutores: new ListTutores(tutorGateway),
    createTutor: new CreateTutor(tutorGateway),
    updateTutor: new UpdateTutor(tutorGateway),
    arquivarTutor: new ArquivarTutor(tutorGateway),
    listAssuntos: new ListAssuntos(assuntoGateway),
    createAssunto: new CreateAssunto(assuntoGateway),
    updateAssunto: new UpdateAssunto(assuntoGateway),
    listSolicitacoes: new ListSolicitacoes(solicitacaoGateway),
    assumirSolicitacao: new AssumirSolicitacao(solicitacaoGateway),
    listSolicitacaoMensagens: new ListSolicitacaoMensagens(solicitacaoGateway),
    responderSolicitacao: new ResponderSolicitacao(solicitacaoGateway),
    encerrarSolicitacao: new EncerrarSolicitacao(solicitacaoGateway),
  };

  return { useCases };
}
